// Canonical languages Twilio ConversationRelay supports. Shared by the DiVA
// config UI (Views/AIChatbots.js) and the IVR flow builder (Views/IVRFlows.js)
// so the two stay in sync. Seeded from the set IVRFlows.js already shipped;
// expand toward the fuller ConversationRelay locale set as needed.
export const DEFAULT_LANG = 'en-US';

export const CR_LANGUAGES = [
	{ code: 'en-US', label: 'English (US)' },
	{ code: 'es-US', label: 'Spanish (US)' },
	{ code: 'es-MX', label: 'Spanish (Mexico)' },
	{ code: 'fr-FR', label: 'French' },
	{ code: 'fr-CA', label: 'French (Canada)' },
	{ code: 'de-DE', label: 'German' },
	{ code: 'it-IT', label: 'Italian' },
	{ code: 'pt-BR', label: 'Portuguese (Brazil)' },
	{ code: 'zh-CN', label: 'Chinese (Mandarin)' },
	{ code: 'ja-JP', label: 'Japanese' },
	{ code: 'ko-KR', label: 'Korean' }
];

// Friendly label for a language code; falls back to the raw code if unknown.
export function languageLabel(code) {
	var m = CR_LANGUAGES.find(function (l) { return l.code === code; });
	return m ? m.label : code;
}
